import {
    FETCH_CHAT_USERS_REQUEST,
    FETCH_CHAT_USERS_SUCCESS,
    FETCH_CHAT_USERS_FAILURE
} from "../../constants";

import { pharmacy_chat_users } from "../../../networking/urlEndPoints";
import Axios from '../../../networking/intraceptor'

export const fetchChatListRequest = () => ({
    type: FETCH_CHAT_USERS_REQUEST,
})

export const fetchChatListSuccess = (data) => ({
    type: FETCH_CHAT_USERS_SUCCESS,
    payload: data,
})

export const fetchChatListFailure = (error) => ({
    type: FETCH_CHAT_USERS_FAILURE,
    payload: error,
})

export const FetchPharmacyChatUsers = (user_name, setRecenetChatLoading) => {
    return async (dispatch) => {
        dispatch(fetchChatListRequest())
        try {

            let url = pharmacy_chat_users;
            if (user_name && user_name.trim() !== '') {
                url += `?search=${encodeURIComponent(user_name)}`; // Use encodeURIComponent to safely encode the parameter
            }

            const response = await Axios.get(url)

            if (response?.status === 200) {
                dispatch(fetchChatListSuccess(response?.data))
                if (typeof setRecenetChatLoading === 'function') {
                    setRecenetChatLoading(false)
                }
            }
        } catch (error) {
            if (error?.response) {
                dispatch(fetchChatListFailure(error?.response))
            }
            if (typeof setRecenetChatLoading === 'function') {
                setRecenetChatLoading(false)
            }
        }
    }
}
